export const baseUrl = 'https://stripe-gateway-15c66b25fd2e.herokuapp.com';

export const URL_PATHS = {
  CONFIG: 'config',
  CREATE_CUSTOMER_AND_SUBSCRIPTION: 'create-customer-and-subscription',
};
